/**
 * @fileoverview ページトップへ戻るボタンの制御
 * @description クリック時にトップまでスムーススクロールします。
 */
/**
 * スムーススクロール実行
 */
const initGoToTop = function () {
	const toTop = document.querySelector('.js-to-top');
	if (!toTop) return;

	const toTopBtn = toTop.querySelector('a');
	if (!toTopBtn) return;

	toTopBtn.addEventListener('click', e => {
		e.preventDefault();
		if (typeof animateScrollTo === 'function') {
			animateScrollTo(0, 700);
		}
	});
};

/**
 * 初期化実行
 */
document.addEventListener('DOMContentLoaded', () => {
	initGoToTop();
});